import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="evaluation_form"
export default class extends Controller {
    static targets = ["evaluationType", "promotion", "learningModule", "course"]

    connect() {
        console.log("EvaluationFormController connected")
        this.toggleFields()
    }

    toggleFields() {
        console.log("toggleFields")
        const type = this.evaluationTypeTarget.value
        this.promotionTarget.classList.toggle("hidden", type !== "promotion")
        this.learningModuleTarget.classList.toggle("hidden", type !== "module")
        this.courseTarget.classList.toggle("hidden", type !== "course")
    }

    changeType() {
        console.log("changeType")
        this.toggleFields()
    }
} 